export const PhishingVulnerabilityTrend = r => require.ensure([], () => r(require('../components/list/phishing_vulnerability_trend')), 'report-bundle')

export const AwarenessTrendsLook = r => require.ensure([], () => r(require('../components/list/awareness_trends_look')), 'report-bundle')

export const ReportingTrend = r => require.ensure([], () => r(require('../components/list/reporting_trend')), 'report-bundle')

export const Weekest = r => require.ensure([], () => r(require('../components/list/weekest')), 'report-bundle')

export const Strongest = r => require.ensure([], () => r(require('../components/list/strongest')), 'report-bundle')

export const Deparmentweakest = r => require.ensure([], () => r(require('../components/list/deparmentweakest')), 'report-bundle')

export const Highrisk = r => require.ensure([], () => r(require('../components/list/highrisk')), 'report-bundle')


// WEBPACK FOOTER //
// ./src/app/managementreport/routes/components.js